import React, { useState } from "react";
import {
  FaArrowAltCircleRight,
  FaGithub,
  FaGlobeAmericas
} from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import propic from "../../assets/images/propic.png";  
import "./Work.css";
const Work = ({ title, category, desciption, id, diff, index, workpic, technologies, admin, client, website, gitlink, sitelink, adminlink, clientlink }) => {
  // const [repoShow, setRepoShow] = useState(false);s
  const [hovered, setHovered] = useState(false);
  const handleHover = () => {
    setHovered(!hovered);
  };
  return (
    <div
      className={`bg-transparent border border-1 border-green-500 drop-shadow-lg rounded-2xl  duration-200 overflow-hidden flex flex-col  ${
        index % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
      }`}
    >
      <div className={`image-container md:w-[50%] ${hovered ? "hovered" : ""}`}>
        <img
          className="image"
          onMouseEnter={handleHover}
          onMouseLeave={handleHover}
          src={workpic}
          alt=""
        />
      </div>

      <div className="px-5 my-5 flex flex-col justify-center md:w-[50%] items-center">
        <h3 className=" font-roboto text-2xl mt-3 text-green-500 font-bold uppercase">{title}</h3>
        <p className="text-[14px] my-2 text-white">
          {desciption}
        </p>
        {/* tags */}
        <h5 className="text-[12px] mb-3 font-roboto text-white">
          Technologies: {technologies}
        </h5>
        <div className="md:space-x-5 md:flex justify-center items-center">
          <a href={gitlink} className="px-3 py-3 bg-[#0e0f17] mb-4 md:mb-0 text-white  hover:bg-transparent border-2 border-transparent hover:border-green-500 duration-300 flex  items-center rounded-md space-x-2 cursor-pointer" target="_blank" title={`View Github Repository`}>
            <FaGithub className="2xl:mr-2 text-[24px]" />
            <span className="">Github</span>
          </a>
          {website && (
            <a href={sitelink} className="px-3 py-3 bg-[#0e0f17] mb-4 md:mb-0 text-white  hover:bg-transparent border-2 border-transparent hover:border-green-500 duration-300 flex  items-center rounded-md space-x-2 cursor-pointer" target="_blank" title={`View Live Website ${title}`}>
              <FaGlobeAmericas className="2xl:mr-2 text-[24px]" />
              <span className="">Live Site</span>
          </a>
          )}
          
          {admin && (
            <a href={adminlink} className="px-3 py-3 bg-[#0e0f17] mb-4 md:mb-0 text-white  hover:bg-transparent border-2 border-transparent hover:border-green-500 duration-300 flex  items-center rounded-md space-x-2 cursor-pointer" target="_blank" title={`View Admin Dashboard of ${title}`}>
              <MdDashboard className="2xl:mr-2 text-[24px]"  />
              <span className="">Admin Dashboard</span>
            </a> 
          )}

          {client && (
            <a href={clientlink} className="px-3 py-3 bg-[#0e0f17] mb-4 md:mb-0 text-white  hover:bg-transparent border-2 border-transparent hover:border-green-500 duration-300 flex  items-center rounded-md space-x-2 cursor-pointer" target="_blank" title={`View Client Dashboard of ${title}`}>
              <MdDashboard className="2xl:mr-2 text-[24px]"  />
              <span className="">Client Dashboard</span>
            </a> 
          )}
          
          
        </div>
      </div>
    </div>
  );
};

export default Work;
